module.exports = __webpack_public_path__ + "img/planet.9cb22581.png";